var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"columns columns-2 product-meta-price"},[_c('div',{staticClass:"product-meta"},[_vm._v(_vm._s(_vm.product.product_id)),_c('br'),_vm._v("UPC: "+_vm._s(_vm.product.upc))]),_c('div',{staticClass:"product-price",domProps:{"innerHTML":_vm._s(_vm.$formatPrice(_vm.product.price))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }